import * as React from "react";
import { createRoot } from "react-dom/client";
import { Loading } from "@skve/components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "@/App";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { setupPwa } from "@/config.codegen";

setupPwa();

const root = createRoot(document.querySelector("#app")!);

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // Disabled for now; we need to see later how to proceed here
      //refetchInterval: 45_000, // refetch every 45s - once WS is connected this is removed
      staleTime: 300_000, // consider data stale after 5 min
    },
  },
});

root.render(
  <ThemeProvider defaultTheme="dark" storageKey="portal:ui/theme">
    <React.Suspense fallback={<Loading />}>
      <QueryClientProvider client={client}>
        <App />
      </QueryClientProvider>
    </React.Suspense>
  </ThemeProvider>,
);
